import React from 'react'
import type { Icon } from 'shared/utils'

export const Bag = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'bag',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M7.36 3.243A5 5 0 019.21.939a5.171 5.171 0 012.851-.89 4.265 4.265 0 012.227.254 4.168 4.168 0 011.773 1.343c.293.498.507 1.036.636 1.597h-2.4c-.375-.942-1.11-1.07-2.236-1.022-.415.01-.823.106-1.198.282a2.914 2.914 0 00-.972.74H7.36zm15.442 17.564c-.31-4.104-.898-15.409-.898-15.409H2.513l-.506 16.175c0 1.293-.196 2.203 1.518 2.3 1.714.095 4.031.127 6.415.127h9.793c3.95 0 3.265-.878 3.15-3.193"
                fillRule="evenodd"
            />
        </svg>
    )
}
